import { reqF } from "./axiosFun";
export async function homePageRequest(action, params = {}) {
	const res = await reqF("post", "/api/sysConfig/HomePage/" + action, params);
	if (res.code !== 1) throw new Error(res.msg || "操作失败");
	return res.data;
}
